import qs from 'qs'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ApiPublicTag } from '../tags'

const accessQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  paramsSerializer: (params) => {
    return qs.stringify(params)
  },
})

export const apiPublic = createApi({
  reducerPath: 'api.public',
  baseQuery: accessQuery,
  tagTypes: Object.values(ApiPublicTag),
  // eslint-disable-next-line no-unused-vars
  endpoints: (_builder) => ({}),
})
